export class DropDownClass{
    id:number;
    label:string;
    is_selected:string;
}